import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=1ca0d406&scoped=true&lang=pug"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js"
import style0 from "./Breadcrumbs.vue?vue&type=style&index=0&id=1ca0d406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca0d406",
  null
  
)

export default component.exports